import React from 'react';
import PropTypes from 'prop-types';

import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';

import { createInviteUser, closeUserSuccess } from '../../actions/user';
import { openDialog, closeDialog } from '../../actions/dialog';

import DialogForm from '../shared/DialogForm';
import UserInviteSuccess from './UserInviteSuccess';

const FORM_ID = 'userSuccessForm';

export class UserInviteSuccessContainer extends React.Component {
  static propTypes = {
    cancelDialogFunction: PropTypes.func.isRequired,
    closeDialogAction: PropTypes.func.isRequired,
    closeUserSuccessAction: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    show: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired,
    successFunction: PropTypes.func.isRequired,
    userInvite: PropTypes.object.isRequired,
  };

  performCloseSuccess = params => {
    const { closeUserSuccessAction, successFunction, closeDialogAction } = this.props;
    const notificationInfo = params.noNotification;
    successFunction();
    closeUserSuccessAction(notificationInfo);
    closeDialogAction();
  };

  render() {
    const { cancelDialogFunction, userInvite, show, handleSubmit, submitting } = this.props;

    const dialogContent = (
      <UserInviteSuccess
        firstName={userInvite.firstName}
        lastName={userInvite.lastName}
        closeFunction={cancelDialogFunction}
        submitFunction={this.performCloseSuccess}
        handleSubmit={handleSubmit}
        submitting={submitting}
      />
    );

    return (
      <DialogForm
        cancelFunction={cancelDialogFunction}
        content={dialogContent}
        id="successDialog"
        show={show}
        successText="Got It"
        title="Thanks"
      />
    );
  }
}

const validate = () => {
  const errors = {};
  return errors;
};

const UserInviteSuccessContainerRF = reduxForm({
  form: FORM_ID,
  validate,
})(UserInviteSuccessContainer);

function mapStateToProps(state) {
  const { userInvite } = state;
  const initialValues = { noNotification: false };
  return { userInvite, initialValues };
}

export default connect(mapStateToProps, {
  createInviteUserAction: createInviteUser,
  closeUserSuccessAction: closeUserSuccess,
  openDialogAction: openDialog,
  closeDialogAction: closeDialog,
})(UserInviteSuccessContainerRF);
